<template>
  <svg class="icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.4203 13.2071L23.1274 12.5L22.4203 11.7929L14.6421 4.01469L13.2279 5.42891L19.299 11.5H1.49997L1.49997 13.5H19.299L13.2279 19.571L14.6421 20.9853L22.4203 13.2071Z"
    />
  </svg>
</template>
